/**
 * Created by chenjia on 2016/9/22.
 */
define(function (require, exports, module) {
    var Config = require('../../Config/Config');

    var indexV2Model = {
        // ajaxGetProcess: function (data, success, error) {
        //     if (Config.debug == true) {
        //     } else {
        //         $.ajax({
        //             url: Config.serviceInterface.getQiangNum,
        //             data: data,
        //             method: 'get',
        //             dataType: 'jsonp',
        //             success: function (data) {
        //                 if (data) {
        //                     if ($.isFunction(success)) {
        //                         success(data);
        //                     }
        //                 }
        //             }
        //         });
        //     }
        // },
        getBrowserHistory: function(data, success, error) {
            if (Config.debug == true) {
            } else {
                $.ajax({
                    url: Config.serviceInterface.getBrowserHistory,
                    data: data,
                    method: 'get',
                    dataType: 'jsonp',
                    success: function (data) {
                        if (data) {
                            if ($.isFunction(success)) {
                                success(data);
                            }
                        }
                    }
                });
            }
        },
        ajaxRecommend: function(data, success, error) {
            $.ajax({
                url: "//diviner.jd.com/diviner?lid=1&lim="+data.lim+"&ec=utf-8&uuid=&pin=" + data.pin + "&c1=&c2=&c3=&sku=&hi=brand:,price:,keyword:" + data.keyword + "&p=619010",
                dataType: 'jsonp',
                jsonpCallback: "jsonpCallback",
                success: function(data) {
                    if ($.isFunction(success)) {
                        success(data);
                    }
                }
            });
        }
    };

    module.exports = indexV2Model;
});


// WEBPACK FOOTER //
// ./src/js/model/indexV2Model/indexV2Model.js